import { render, staticRenderFns } from "./StepPayReject.vue?vue&type=template&id=7843358a&scoped=true"
import script from "./StepPayReject.vue?vue&type=script&lang=js"
export * from "./StepPayReject.vue?vue&type=script&lang=js"
import style0 from "./StepPayReject.vue?vue&type=style&index=0&id=7843358a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7843358a",
  null
  
)

export default component.exports